import IconLoader from '../icons/loader';
import { SidePanelLoaderTypes } from './types';

import './styles.css';

export default function SidePanelLoader({
  className,
}: SidePanelLoaderTypes): React.JSX.Element {
  return (
    <div className={`sidepanel-loader ${className}`}>
      <IconLoader />
    </div>
  );
}
